module.exports = __webpack_public_path__ + "img/chpc_index_honor11.4bdd4a6c.png";